module.exports = __webpack_public_path__ + "images/trustpilot/trustpilot-logo.svg";